<template>
    <div class="details">
        <el-row>
            <el-col :span="3">
                <ul>
                    <li>物流-关于产品尺寸要求</li>
                </ul>
            </el-col>
            <el-col :span="20" :offset="1">
                <div>
                    <h3>物流-关于产品尺寸要求</h3>
                </div>
            </el-col>
        </el-row>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400"
        ></el-pagination>
    </div>
</template>

<script>
export default {
    name: "app",
    data() {
        return {
            currentPage4: 4
        };
    },
    mounted() {},
    created() {},
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }
    }
};
</script>

<style lang="scss" scoped>
.details {
    width: 98%;
}
ul {
    border: 1px #eee solid;
    li {
        line-height: 40px;
        text-align: center;
    }
}
h3 {
    text-align: center;
    line-height: 45px;
}
</style>